import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { pickDefined, request, validatePairRole } from './common.js';

export async function clientsCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'list';
  switch (action) {
    case 'list':
      return request(args, Methods.Clients);
    case 'current':
      return request(args, Methods.ClientsCurrent);
    case 'delete': {
      const clientId = args.positionals[2] ?? flag(args.flags, 'client-id');
      if (!clientId) throw new CliError('clients delete requires <client-id>', ExitCode.Usage);
      return request(args, Methods.ClientsDelete, { clientId });
    }
    case 'pair-begin': {
      const role = validatePairRole(flag(args.flags, 'role'));
      return request(args, Methods.ClientsPairStart, pickDefined({ role }));
    }
    case 'pair-cancel':
      return request(args, Methods.ClientsPairCancel);
    default:
      throw new CliError(`Unknown clients action "${action}"`, ExitCode.Usage);
  }
}
